import { FormLabel, Grid, TextField, Typography } from "@mui/material";
import { useProyecto } from "../../../data/ProyectoContext";
import { iProyectoABP } from "../../../interfaces/Proyecto/iProyecto";

const Contexto = () => {
  const { proyecto, setProyecto } = useProyecto();

  //función para guardar el campo de texto libre en el objeto
  const handleIndicationsProyectChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { value } = event.target;
    setProyecto({
      ...proyecto,
      caracteristicas_estudiantes: value,
    });
  };
  return (
    <Grid xs={12} lg={12} md={12}>
      <Typography
        sx={{
          color: "#336B87",
          fontFamily: "montserrat",
          fontSize: "1.25rem",
          fontWeight: "bold",
        }}
      >
        Características de los estudiantes
      </Typography>

      <FormLabel
        component="p"
        sx={{
          fontFamily: "montserrat",
          m: 0,
          pb: 2,
          fontSize: "0.85rem",
        }}
      >
        Añade información complementaria sobre tus estudiantes que pueda ser
        relevante para diseñar proyectos de aprendizaje.
      </FormLabel>
      <Grid item xs={12} sm={12}>
        <TextField
          variant="outlined"
          fullWidth
          placeholder="Ejemplo: La escuela está situada en una área con escasez de agua"
          InputProps={{
            sx: {
              borderRadius: 2,
              mb: 3,
              fontFamily: "montserrat",
              fontSize: "0.75rem",
              color: "#005559",
              "&::placeholder": {
                color: "#005559",
              },
              "&:before": {
                borderBottomColor: "#336B87",
              },
              "&:after": {
                borderBottomColor: "#005559",
              },
            },
          }}
          id="outlined-multiline-static"
          value={(proyecto as iProyectoABP).caracteristicas_estudiantes}
          onChange={handleIndicationsProyectChange}
        />
      </Grid>
    </Grid>
  );
};

export default Contexto;
